import { api } from "@/lib/api";
import { audioRunning, currentSub, enablePush, pushSupported } from "@/lib/push";
import { isOrderSound } from "@/lib/orderSound";

export const ASK_KEY = "fsc_print_notify_asked";
export const DENIED = "As notificações estão bloqueadas neste navegador. Clique no cadeado ao lado do endereço do site → Notificações → Permitir e recarregue a página.";
export const notifyState = () => (pushSupported() ? Notification.permission : "unsupported");

let handler = null;
export const setPrintHandler = (fn) => { handler = fn; };

// Toda aba responde ao Service Worker; só a aba do painel (com handler) imprime e toca.
const soundOk = () => isOrderSound() && audioRunning();
const go = (url) => {
  if (!url || window.location.pathname === url) return;
  window.history.pushState(null, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export function listenPrintMessages() {
  navigator.serviceWorker?.addEventListener("message", (e) => {
    const port = e.ports?.[0];
    const type = e.data?.type;
    if (type === "fsc-open") { go(e.data.url); return; }
    if (type === "fsc-ping") { port?.postMessage({ panel: !!handler }); return; }
    if (type !== "fsc-print" && type !== "fsc-order") return;
    if (!handler) { port?.postMessage({ panel: false }); return; }
    window.dispatchEvent(new Event("fsc-order-check"));
    if (type === "fsc-order") { port?.postMessage({ panel: true, sound: soundOk() }); return; }
    handler(e.data).catch(() => ({ alive: true, printed: false })).then((r) => port?.postMessage({ panel: true, sound: soundOk(), ...r }));
  });
}

export async function syncPrintPush(on) {
  if (!pushSupported()) return;
  await navigator.serviceWorker.register("/sw.js");
  if (Notification.permission !== "granted") return;
  if (on) {
    await enablePush({ print_central: true });
    return;
  }
  const sub = await currentSub();
  if (sub) await api.post("/push/subscribe", { ...sub.toJSON(), print_central: false });
}

export async function enablePrintPush(on) {
  try {
    await enablePush({ print_central: on });
  } catch (e) {
    throw new Error(Notification.permission === "denied" ? DENIED : e?.message || String(e));
  }
}

export async function testPrintPush(on) {
  await enablePrintPush(on);
  const sub = await currentSub();
  await api.post("/push/print-test", { endpoint: sub.endpoint });
}

// Timer num Worker: o navegador não desacelera como faz com a aba em segundo plano.
export function bgTimer(fn, ms) {
  try {
    const url = URL.createObjectURL(new Blob([`setInterval(() => postMessage(0), ${ms});`], { type: "text/javascript" }));
    const w = new Worker(url);
    w.onmessage = fn;
    return () => { w.terminate(); URL.revokeObjectURL(url); };
  } catch {
    const t = setInterval(fn, ms);
    return () => clearInterval(t);
  }
}
